module.exports = __webpack_public_path__ + "static/tricolor-dc3df2523d3d06a4b60adcec22e3e757.svg";